module.exports = __webpack_public_path__ + "media/images/landing_page/2023/album/album_large_en-af15a41fe56153cd457562fdf9d196ed.png";